import { StyleSheet } from 'aphrodite';
import { white } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	selectTrigger: {
		height: 38,
		width: 140,
		maxWidth: 140,
		whiteSpace: 'nowrap',
		backgroundColor: white,
	},
});
